import React from "react";

const FeatureCard = ({ icon, title, description, gradient = false }) => {
  return (
    <div
      className={`group p-8 rounded-2xl hover:shadow-xl transition-all ${
        gradient
          ? "bg-gradient-to-br from-emerald-50 to-teal-50"
          : "bg-white border border-gray-200 hover:border-emerald-300"
      }`}
    >
      <div className="text-5xl mb-4">{icon}</div>
      <h3 className="text-2xl font-bold text-gray-900 mb-3">
        {title}
      </h3>
      <p className="text-gray-600 leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default FeatureCard;
